







import { Component, Mixins } from 'vue-property-decorator'
import RecommendItem from './mixins/RecommendItem'

@Component
export default class AdvertiseItem1 extends Mixins(RecommendItem) {
  get goDetailExposure() {
    const { title, linkUrl } = this.value
    return `200024||${JSON.stringify({ name: title, link: linkUrl, tabname: this.tab.tabName })}`
  }
  async goDetail() {
    const { title, linkUrl } = this.value
    this.$newClickTracker({ ...this.pageTrackParams, clickId: '200024', positionParam: { name: title, link: linkUrl, tabname: this.tab.tabName } })
  }

  // get linkUrl() {
  //   return this.kwtarget(this.value.linkUrl)
  // }
}
